import React from "react";
import { Link, useNavigate } from "react-router-dom";

const Card = ({ product }) => {
  const navigate = useNavigate();

  return (
    <div
      className="Card"
      onClick={() => navigate(`/product/${product.sku}`)}
      type="button"
    >
      <img
        src={product.image}
        alt="product"
        className="prod-img"
      />

      <div className="mt-2">
        <p className="category text-muted my-1">{product.Category}</p>

        <Link to={`/product/${product.id}`} className="title title_truncate fs-5 mt-2 fw-bold">
          {product.description}
        </Link>

          <p className="price fs-5 fw-bold mt-2" style={{ color: "#024e82" }}>{product.price?.toLocaleString("es-ES", { minimumFractionDigits: 2, maximumFractionDigits: 2 })} €</p>
      </div>
    </div>
  );
};

export default Card;
